// extracted by mini-css-extract-plugin
module.exports = {"tags":"Tags_tags__1M-Vf","fadeIn":"Tags_fadeIn__1UP-2","scaleXin":"Tags_scaleXin__1zNMm"};